import { BoxDocumentCommunicationRequest } from '@fednot/certinot-api';

import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type {
  CommunicationDetails,
  DeleteCommunicationParams,
  DownloadCommunicationDocumentParams,
  GetCommunicationsParams,
  GetCommunicationsResponse,
} from './types';

class CommunicationsApi {
  protected baseUrl = '/box/communications';

  constructor(protected fetchService: FetchService) {}

  getCommunication(id: string) {
    return this.fetchService.get<CommunicationDetails>(`${this.baseUrl}/${id}`);
  }

  getCommunications(params: GetCommunicationsParams) {
    const qs = buildQueryString(params);
    return this.fetchService.get<GetCommunicationsResponse>(`${this.baseUrl}${qs}`);
  }

  copyCommunicationDocuments(communicationId: string, documentIds: Array<string>) {
    return this.fetchService.post(`${this.baseUrl}/${communicationId}/documents/copy`, {
      documents: documentIds,
    });
  }

  async downloadCommunicationDocument(
    communicationId: string,
    documentId: string,
    params: DownloadCommunicationDocumentParams,
  ) {
    const qs = buildQueryString(params);
    return this.fetchService.get<Blob>(
      `${this.baseUrl}/${communicationId}/documents/${documentId}/download${qs}`,
      { resAsBlob: true },
    );
  }

  createCommunication(communicationRequest: BoxDocumentCommunicationRequest) {
    return this.fetchService.post(this.baseUrl, communicationRequest);
  }

  deleteCommunications(params: DeleteCommunicationParams) {
    return this.fetchService.post(`${this.baseUrl}/delete`, params);
  }
}

export default CommunicationsApi;
